import React from 'react';
import InternshipListing from '../../components/common/InternshipListing/InternshipListing';

const Internships = () => {
  return (
    <div>
      <InternshipListing />
    </div>
  );
};

export default Internships;